export const CATS = [
  {id:'all',        label:'Tümü',         icon:'✦', color:'#A8DAFF'},
  {id:'anaokul',    label:'Anaokul/Kreş', icon:'🏫',color:'#FF6B6B'},
  {id:'oyunevi',    label:'Oyunevi',      icon:'🎠',color:'#4ECDC4'},
  {id:'atolye',     label:'Atölye',       icon:'🎨',color:'#FFE66D'},
  {id:'kurs',       label:'Kurs',         icon:'📚',color:'#FFA94D'},
  {id:'ozel',       label:'Özel Eğitim',  icon:'💜', color:'#8B5CF6'},
  {id:'spor',       label:'Spor Okulu',   icon:'⚽',color:'#FF8C42'},
  {id:'muzik',      label:'Müzik/Dans',   icon:'🎵',color:'#F472B6'},
];

export const TC = {anaokul:'#FF6B6B',oyunevi:'#4ECDC4',atolye:'#FFE66D',kurs:'#FFA94D',ozel:'#8B5CF6',spor:'#FF8C42',muzik:'#F472B6'};

export const MODES = [
  {id:'normal',label:'Normal'},
  {id:'heat',  label:'🔥 Isı'},
  {id:'safety',label:'🛡 Güvenlik'},
  {id:'cluster',label:'📍 Küme'},
  {id:'zone',  label:'🗺 Bölge'},
];

export const NOTIFICATIONS = [
  {id:1,type:'new', icon:'🏫',title:'Yeni Kurum Eklendi',   body:"Moda'da 'Akıllı Adımlar Montessori' hizmete açıldı.",               time:'2 dk önce',  read:false,color:'#4ECDC4'},
  {id:2,type:'promo',icon:'🎉',title:'Erken Kayıt Fırsatı', body:'Güneş Anaokulu Eylül 2026 kayıtlarında %15 indirim sunuyor.',       time:'1 saat önce', read:false,color:'#FFE66D'},
  {id:3,type:'fav', icon:'❤️',title:'Favori Güncellendi',   body:"Atölye Çocuk'un doluluk oranı %96'ya çıktı. Hızlı ol!",            time:'3 saat önce', read:true, color:'#FF6B6B'},
  {id:4,type:'new', icon:'🎠',title:'Yeni Oyunevi',          body:"Yeldeğirmeni'nde 'Wonder World' açılışa özel ücretsiz giriş.",       time:'Dün',         read:true, color:'#4ECDC4'},
  {id:5,type:'promo',icon:'📅',title:'Açık Kapı Günleri',   body:'Kod Yıldızları bu hafta sonu ücretsiz deneme dersi sunuyor.',       time:'2 gün önce',  read:true, color:'#A8DAFF'},
];

export const BADGES = [
  {key:'montessori',     label:'Montessori Sertifikalı',    emoji:'🎓', cat:'egitim'},
  {key:'waldorf',        label:'Waldorf Metodu',             emoji:'🌱', cat:'egitim'},
  {key:'reggio',         label:'Reggio Emilia',              emoji:'🧠', cat:'egitim'},
  {key:'meb_onayli',     label:'MEB Onaylı Program',         emoji:'📚', cat:'egitim'},
  {key:'ingilizce',      label:'İngilizce Eğitim',           emoji:'🌍', cat:'egitim'},
  {key:'sanat_odakli',   label:'Sanat Odaklı',               emoji:'🎨', cat:'egitim'},
  {key:'muzik',          label:'Müzik Eğitimi',              emoji:'🎵', cat:'egitim'},
  {key:'satranc',        label:'Satranç Programı',           emoji:'♟️', cat:'egitim'},
  {key:'robotik',        label:'Robotik & Kodlama',          emoji:'🤖', cat:'egitim'},
  {key:'bahceli',        label:'Bahçeli',                    emoji:'🌳', cat:'tesis'},
  {key:'yuzme',          label:'Yüzme Havuzu',               emoji:'🏊', cat:'tesis'},
  {key:'tiyatro',        label:'Tiyatro Salonu',             emoji:'🎭', cat:'tesis'},
  {key:'spor_salonu',    label:'Spor Salonu',                emoji:'🏋️', cat:'tesis'},
  {key:'guvenlik_kamera',label:'Güvenlik Kamerası',          emoji:'📹', cat:'tesis'},
  {key:'kartli_giris',   label:'Kartlı Giriş',               emoji:'🚪', cat:'tesis'},
  {key:'saglik_odasi',   label:'Sağlık Odası',               emoji:'🏥', cat:'tesis'},
  {key:'servis',         label:'Servis Hizmeti',             emoji:'🚌', cat:'tesis'},
  {key:'organik_yemek',  label:'Organik Yemek',              emoji:'🍽️', cat:'tesis'},
  {key:'hijyen_5yildiz', label:'5 Yıldız Hijyen',            emoji:'⭐', cat:'kalite'},
  {key:'yilin_okulu',    label:'Yılın Okulu',                emoji:'🏆', cat:'kalite'},
  {key:'iso',            label:'ISO Sertifikalı',            emoji:'✅', cat:'kalite'},
  {key:'hemsire',        label:'Tam Zamanlı Hemşire',        emoji:'👩‍⚕️', cat:'kalite'},
  {key:'profesyonel_sef',label:'Profesyonel Şef',            emoji:'👨‍🍳', cat:'kalite'},
  {key:'gunluk_fotograf',label:'Günlük Fotoğraf',            emoji:'📸', cat:'kalite'},
  {key:'doga_dostu',     label:'Doğa Dostu Okul',            emoji:'🌿', cat:'cevre'},
  {key:'geri_donusum',   label:'Geri Dönüşüm',               emoji:'♻️', cat:'cevre'},
  {key:'gunes_enerjisi', label:'Güneş Enerjisi',             emoji:'☀️', cat:'cevre'},
  {key:'okul_bahcesi',   label:'Okul Bahçesi & Tarım',       emoji:'🌻', cat:'cevre'},
  {key:'su_tasarrufu',   label:'Su Tasarrufu',               emoji:'💧', cat:'cevre'},
  {key:'ozel_gereksinimli',label:'Özel Gereksinimli Uyumlu', emoji:'💜', cat:'kapsayici'},
  {key:'cok_dilli',      label:'Çok Dilli Eğitim',           emoji:'🌐', cat:'kapsayici'},
  {key:'kapsayici',      label:'Kapsayıcı Eğitim',           emoji:'🤝', cat:'kapsayici'},
  {key:'aile_katilimli', label:'Aile Katılımlı Program',     emoji:'👨‍👩‍👧', cat:'kapsayici'},
  {key:'okulbot',        label:'OkulBot ile Yönetiliyor',    emoji:'📱', cat:'dijital'},
  {key:'dijital_takip',  label:'Dijital Gelişim Takibi',     emoji:'📊', cat:'dijital'},
  {key:'anlik_bildirim', label:'Anlık Veli Bildirimi',       emoji:'💬', cat:'dijital'},
  {key:'canli_kamera',   label:'Canlı Sınıf Kamerası',       emoji:'📹', cat:'dijital'},
  {key:'kardes_indirimi',label:'Kardeş İndirimi',            emoji:'👫', cat:'fiyat'},
];

export const BADGE_CAT_LABELS = {egitim:'📚 Eğitim',tesis:'🏗 Tesis',kalite:'⭐ Kalite',cevre:'🌿 Çevre',kapsayici:'🤝 Kapsayıcı',dijital:'📱 Dijital',fiyat:'💰 Fiyat'};
